import { render, staticRenderFns } from "./BigNavIconNoRouter.vue?vue&type=template&id=4e24ac5c&scoped=true&"
import script from "./BigNavIconNoRouter.vue?vue&type=script&lang=js&"
export * from "./BigNavIconNoRouter.vue?vue&type=script&lang=js&"
import style0 from "./BigNavIconNoRouter.vue?vue&type=style&index=0&id=4e24ac5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e24ac5c",
  null
  
)

export default component.exports